import React from "react";
import Carousel from "react-bootstrap/Carousel";
import client1 from "../../assets/images/home/client1.png";
import client2 from "../../assets/images/home/client2.png";
import client3 from "../../assets/images/home/client3.png";
import starImg from "../../assets/images/home/starImg.png";

export const WhatOurClients = () => {
  return (
    <div className="whatContainer">
      <div className="container">
        <div className="whatTitle">What Our Clients Say</div>
        <div className="whatSubTitle">
          Read the success stories and heartfelt testimonials from our valued
          clients. Discover why they chose SnapBid for their real estate needs.
        </div>
        <div className="carouselPart">
          <Carousel>
            <Carousel.Item>
              <div className="whatCardGrid">
                <div className="whatCard">
                    <div className="whatCardStar"><img src={starImg}/></div>
                  <div className="whatCardContent">
                    <div>Exceptional Service!</div>
                  <div>
                    “SnapBid made it so easy to find and bid on our plot.
                    Visiting the site before bidding gave us total confidence.
                    Visiting the site before bidding gave us total confidence.”
                  </div>
                  </div>
                  <div className="clientImgContainer">
                    <div><img src={client1}/></div>
                    <div className="clientName">
                       <span>Sampath</span>
                       <span>Hyderabad</span>
                    </div>
                  </div>
                </div>
                <div className="whatCard">
                    <div className="whatCardStar"><img src={starImg}/></div>
                  <div className="whatCardContent">
                    <div>Efficient and Reliable</div>
                  <div>
                    “Unlike other property sites, SnapBid didn’t overwhelm me. I just scrolled, showed interest, visited the place, and got my chance to bid fairly.”
                  </div>
                  </div>
                  <div className="clientImgContainer">
                    <div><img src={client2}/></div>
                    <div className="clientName">
                       <span>Kavya</span>
                       <span>Hyderabad</span>
                    </div>
                  </div>
                </div>
               <div className="whatCard">
                    <div className="whatCardStar"><img src={starImg}/></div>
                  <div className="whatCardContent">
                    <div>Trusted Advisors</div>
                  <div>
                  “The offline bidding format made the whole process more genuine. No spam calls, no fake urgency — just real people and real properties.”
                  </div>
                  </div>
                  <div className="clientImgContainer">
                    <div><img src={client3}/></div>
                    <div className="clientName">
                       <span>Karthik</span>
                       <span>Hyderabad</span>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
              <Carousel.Item>
              <div className="whatCardGrid">
                <div className="whatCard">
                    <div className="whatCardStar"><img src={starImg}/></div>
                  <div className="whatCardContent">
                    <div>Exceptional Service!</div>
                  <div>
                    “SnapBid made it so easy to find and bid on our plot.
                    Visiting the site before bidding gave us total confidence.
                    Visiting the site before bidding gave us total confidence.”
                  </div>
                  </div>
                  <div className="clientImgContainer">
                    <div><img src={client1}/></div>
                    <div className="clientName">
                       <span>Sampath</span>
                       <span>Hyderabad</span>
                    </div>
                  </div>
                </div>
                <div className="whatCard">
                    <div className="whatCardStar"><img src={starImg}/></div>
                  <div className="whatCardContent">
                    <div>Efficient and Reliable</div>
                  <div>
                    “Unlike other property sites, SnapBid didn’t overwhelm me. I just scrolled, showed interest, visited the place, and got my chance to bid fairly.”
                  </div>
                  </div>
                  <div className="clientImgContainer">
                    <div><img src={client2}/></div>
                    <div className="clientName">
                       <span>Kavya</span>
                       <span>Hyderabad</span>
                    </div>
                  </div>
                </div>
               <div className="whatCard">
                    <div className="whatCardStar"><img src={starImg}/></div>
                  <div className="whatCardContent">
                    <div>Trusted Advisors</div>
                  <div>
                  “The offline bidding format made the whole process more genuine. No spam calls, no fake urgency — just real people and real properties.”
                  </div>
                  </div>
                  <div className="clientImgContainer">
                    <div><img src={client3}/></div>
                    <div className="clientName">
                       <span>Karthik</span>
                       <span>Hyderabad</span>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
    </div>
  );
};
